import React from 'react';

// Menangkap error render (termasuk "Maximum update depth exceeded") agar dilaporkan
// dengan componentStack, bukan membiarkan seluruh root React hilang tanpa jejak.
// Diagnostik dilempar lewat setTimeout supaya tetap sampai ke window.onerror/collector.
class TBCourseErrorBoundary extends React.Component {
    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        const componentStack = info && info.componentStack ? String(info.componentStack).slice(0, 800) : 'n/a';
        const detail = 'message=' + error.message + ' componentStack=' + componentStack + ' path=' + window.location.pathname;
        setTimeout(() => {
            throw new Error('[TB-21259] TBCourse render error: ' + detail);
        }, 0);
    }

    render() {
        return this.props.children;
    }
}

export default TBCourseErrorBoundary;
